import { z } from 'zod';
import { UserStatusSchema } from '../enums.js';
import { EmailSchema, IdSchema, IsoDateTimeSchema } from './common.js';
/** users/{uid} */
export const UserSchema = z.object({
    uid: IdSchema,
    email: EmailSchema,
    displayName: z.string().max(200).optional(),
    photoURL: z.string().url().optional(),
    orgIds: z.array(IdSchema).default([]),
    createdAt: IsoDateTimeSchema,
    lastSeenAt: IsoDateTimeSchema.optional(),
    /** Set by PUT /api/me/status; absent means DEFAULT_USER_STATUS. */
    status: UserStatusSchema.optional(),
    statusChangedAt: IsoDateTimeSchema.optional(),
});
/** users/{uid}/prefs/theme — one of the few client-writable documents. */
export const ThemePrefSchema = z.object({
    theme: z.enum(['light', 'dark', 'system']).default('system'),
});
export const NotificationCategorySchema = z.enum([
    'blocker_raised',
    'task_assigned',
    'comment_mention',
    'task_blocked',
    'task_ready_for_testing',
    'document_pending_validation',
    'regeneration_proposals',
    'discussion_mention',
]);
/** Categories that push by default until the user turns them off — being tagged in a discussion
 * is a direct ask for your attention. Every other category pushes only once opted into (or when
 * the notification is high severity). Read by both notify() and the Settings page. */
export const PUSH_ON_BY_DEFAULT = ['discussion_mention'];
/** users/{uid}/notifications/{id} */
export const NotificationSchema = z.object({
    id: IdSchema,
    category: NotificationCategorySchema,
    title: z.string().max(300),
    body: z.string().max(2000).optional(),
    link: z.string().max(500).optional(),
    severity: z.enum(['low', 'medium', 'high']).default('low'),
    createdAt: IsoDateTimeSchema,
    readAt: IsoDateTimeSchema.nullable().default(null),
});
/** Per-category, per-channel notification preferences, set in Settings. */
export const NotificationPreferencesSchema = z.record(NotificationCategorySchema, z.object({ inApp: z.boolean().default(true), push: z.boolean().default(false) }));
//# sourceMappingURL=user.js.map